<div class="ver-video"  (click)="_openVideo()"> 
      <i class="fab fa-youtube"></i>  
      <span>Assista ao vídeo<br> desta experiência</span>
</div> 